<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5HBB5W/tc-custom/9781613732649.jpg?1740287409904" alt="This image is the cover for the book Case Without a Corpse, Sergeant Beef Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Case Without a Corpse, Sergeant Beef Series
      </h1>
      <p class="bookDescription body article font2">
        <p>This is one of Sgt. Beef's most interesting and perplexing cases. It involves a murder, but one in which no body can be found. Young Rogers announces to Beef and others assembled in a local pub that he has committed a murder—then takes his own life. But where is the victim? How did it happen? "I always supposed," says Beef. "a murder case started with a corpse, and then you had to find out 'oo done it. This time we know 'oo's done it, but we can't find the corpse."</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Leo Bruce
      </h2>
      
      <p class="authorDescription body article">Leo Bruce was the pen name of Rupert Croft-Cooke, who wrote more than twenty highly-praised mysteries featuring Carlous Deene. He also wrote eight mysteries featuring Sgt. William Beef, a cockney police detective who invariably "knows who done it." Croft-Cooke died in 1980.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chicago Review Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8463ab7e